module.exports = __webpack_public_path__ + "img/13.0ec40cb0.jpg";